import { __awaiter } from "tslib";
import addUrlParams from 'pathfinder/modules/DiscoveryModules/shared/addUrlParams';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import waitForOptimizely, { getOptimizelyValue } from 'pathfinder/utils/waitForOptimizely';
import React from 'react';
import ReactDOM from 'react-dom';
import { isThemeDark } from 'utils/getWikiInfo';
import placementHelper from './modules/DiscoveryModuleRailPushToDiscussions/helpers/placementHelper';
import { RAIL_PUSH_TO_DISCUSSIONS } from './modules/DiscoveryModuleRailPushToDiscussions/optimizely';
export const getDiscoveryModuleRailPushToDiscussionsMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    const fandomName = window.location.href.split('https://')[1].split('.fandom.com')[0];
    const defaultValues = isForced
        ? {
            fandomName: fandomName,
            buttonLink: `/f`,
            buttonText: 'Go To Discussions',
            descriptionText: 'Head to discussions',
            headerText: `Want to chat with other ${capitalize(fandomName)} fans like you?`,
            image: '',
        }
        : {
        /* no default values for non-forced module */
        };
    try {
        const reactRoot = document.createElement('div');
        // API
        const show = () => (reactRoot.style.display = '');
        const hide = () => (reactRoot.style.display = 'none');
        if (!isForced) {
            yield waitForOptimizely();
        }
        // read values from optimizely (with fallback)
        moduleProps.fandomName = getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.FANDOM_NAME, defaultValues.fandomName);
        moduleProps.headerText = getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.HEADER_TEXT, defaultValues.headerText);
        moduleProps.image = getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.IMAGE, defaultValues.image);
        moduleProps.descriptionText = getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.DESCRIPTION_TEXT, defaultValues.descriptionText);
        moduleProps.buttonText = getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.BUTTON_TEXT, defaultValues.buttonText);
        moduleProps.buttonLink = addUrlParams(getOptimizelyValue(RAIL_PUSH_TO_DISCUSSIONS.BUTTON_LINK, defaultValues.buttonLink));
        // validate values from Optmizely
        if (!moduleProps.fandomName || !moduleProps.descriptionText || !moduleProps.buttonText || !moduleProps.buttonLink) {
            log.debug('Missing values from Optimizely', moduleProps);
            // fail silenty if values are missing
            return null;
        }
        else {
            log.debug('Successfully read values from Optimizely', moduleProps);
        }
        moduleProps.isDarkTheme = yield isThemeDark();
        const DiscoveryModuleRailPushToDiscussions = yield import(
        /* webpackChunkName: "DiscoveryModuleRailPushToDiscussions" */ './modules/DiscoveryModuleRailPushToDiscussions/DiscoveryModuleRailPushToDiscussions');
        const render = () => {
            ReactDOM.render(React.createElement(DiscoveryModuleRailPushToDiscussions.default, moduleProps), reactRoot);
            return reactRoot;
        };
        const isInserted = placementHelper(moduleProps, reactRoot, isForced);
        return isInserted
            ? {
                render,
                show,
                hide,
            }
            : null;
    }
    catch (error) {
        log.debug('getDiscoveryModuleRailPushToDiscussions error', error);
    }
    return null;
});
